import React from 'react';
import { Loader2 } from 'lucide-react';

const TransactionProgress = ({ currentStep }: { currentStep: 'play' | 'settle' | null }) => {
  if (!currentStep) return null;

  const steps = [
    { id: 'play', label: 'Shaking Dice' },
    { id: 'settle', label: 'Throwing Dice' }
  ];

  const currentIndex = steps.findIndex(step => step.id === currentStep);

  return (
    <div className="w-full max-w-md mx-auto mt-4">
      {/* Brief explainer */}
      <div className="text-sm text-gray-400 text-center mb-4">
        Roll The Dice uses two transactions for secure randomness and fair rewards
      </div>
      
      {/* Progress bar */}
      <div className="relative">
        <div className="absolute left-0 top-2 w-full h-1 bg-gray-700 rounded">
          <div 
            className="h-full bg-accent-500 rounded transition-all duration-500" 
            style={{ 
              width: currentIndex === 0 ? '50%' : '100%'
            }}
          />
        </div>

        {/* Steps */}
        <div className="relative flex justify-between">
          {steps.map((step, idx) => {
            const isActive = idx <= currentIndex;
            const isCurrent = idx === currentIndex;
            
            return (
              <div key={step.id} className="flex flex-col items-center">
                {/* Step circle */}
                <div className={`
                  w-5 h-5 rounded-full border-2 flex items-center justify-center
                  transition-colors duration-300
                  ${isActive ? 'border-accent-500 bg-accent-500' : 'border-gray-700 bg-gray-800'}
                `}>
                  {isCurrent && (
                    <Loader2 className="w-3 h-3 text-white animate-spin" />
                  )}
                </div>
                
                {/* Label */}
                <div className="mt-4 text-sm font-medium text-center">
                  <div className={`
                    ${isActive ? 'text-accent-400' : 'text-gray-500'}
                  `}>
                    {step.label}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TransactionProgress;
